import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { RightArrow, Dots } from '../../assets/svg.js';
import { Block, UnBlock } from '../../assets/svg.js';
import DataTableReact from '../../components/common/datatable/DataTableReact.jsx';
import apiService from '../../services/apiService.js';
import { useNavigate } from 'react-router-dom';
import debounce from 'lodash.debounce';
import CustomDropDown from '../../components/common/dropdown/Dropdown.jsx';
import useMedicalSpecialties from 'components/common/medSpecialty/MedicalSpecialty.jsx';

const Listing = () => {
  const [requestList, setRequestList] = React.useState([]);
  const [Pagination, setPaginaton] = React.useState('');
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [totalRows, setTotalRows] = React.useState(0);
  const [prevPageUrl, setPrevPageUrl] = React.useState(null);
  const [nextPageUrl, setNextPageUrl] = React.useState(null);
  const [loading, setloading] = React.useState(false);
  const [filters, setFilters] = React.useState({
    cluster: '',
    medicalSpecialties: [],
    job_number: '',
    date: '',
  });

  const user = JSON.parse(localStorage.getItem('user'));

  console.log('user', user); // user.role

  const navigate = useNavigate();

  const medSp = useMedicalSpecialties();

  const handleClick = (event, row) => {
    if (row?.original) {
      localStorage.setItem('rowOriginalData', JSON.stringify(row.original));
      localStorage.setItem(
        'title',
        JSON.stringify(row.original?.medical_speciality?.name)
      );
    }

    if (user.role == 'physician_management') {
      navigate(`/Apply`);
    } else if (
      user.role == 'hospital_manager' ||
      user.role == 'MoH Manager' ||
      user.role == 'cluster_manager'
    ) {
      navigate(`/Detail`);
    }
  };

  const handleDebouncedChange = debounce(
    (updatedFilters, page, rowsPerPage) => {
      setloading(true);

      const payload = {
        cluster: String(updatedFilters.cluster || '').toLowerCase(),
        medical_speciality: String(
          updatedFilters.medicalSpecialties
            ?.map((label) => label?.label)
            .join(', ') || ''
        ),
        job_number: String(updatedFilters.job_number || '').toLowerCase(),
        created_at: String(updatedFilters.date || '').toLowerCase(),
      };
      apiService
        .get(
          `announced-jobs?is_pagination=true&per_page=${rowsPerPage}`,
          payload
        )
        .then((response) => {
          setRequestList(response?.data?.data || []);
          setTotalRows(response?.data?.total);
          setloading(false);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    },
    500
  );

  const handleInputChange = (e) => {
    let value;
    let name;

    if (e !== null && e.target) {
      // Standard input or select element
      const { name: inputName, value: inputValue } = e.target;
      name = inputName;
      value = inputValue;
    } else {
      // Custom component like react-select
      name = 'actionStatus'; // Assuming custom component passes 'name'
      value = e; // Assuming value is passed in a custom event object
      if (Array.isArray(value)) {
        name = 'medicalSpecialties'; // Assign to medicalSpecialties
        value = value.map((item) => item);
      } else {
        console.log("It's not an array.", value);
      }
    }

    // Handle special case for 'medicalSpecialties' (if it's a comma-separated list)
    const updatedFilters = {
      ...filters,
      [name]:
        name === 'medicalSpecialties'
          ? value?.map(({ label, value }) => ({ label, value })) || []
          : value,
    };
    setFilters(updatedFilters);
    // Trigger the debounced API call
    handleDebouncedChange(updatedFilters, page, rowsPerPage);
  };

  const columns = [
    {
      id: 'jobNumber',
      header: 'Announcements #',

      Cell: ({ row }) => {
        return (
          <span className="font-sans font-[400] text-[12px] text-[#0A0D14]">
            {row?.original?.jobNumber}
          </span>
        );
      },
    },
    {
      header: 'Medical Speciality',

      Cell: ({ row }) => {
        return (
          <span className="bg-[#EEEBFF] text-[#2B1664] whitespace-normal break-words inline-block m-1 px-1.5 py-0.5 text-[12px] rounded">
            {row?.original?.medical_speciality?.name}
          </span>
        );
      },
    },
    {
      header: 'Practitioner Level',
      Cell: ({ row }) => {
        return (
          <span className="bg-[#FDEBFF] text-[#620F6C] whitespace-normal break-words inline-block m-1 px-1.5 py-0.5 text-[12px] rounded">
            {row?.original?.speciality?.name}
          </span>
        );
      },
    },
    {
      header: 'Cluster Name',

      Cell: ({ row }) => {
        return (
          <>
            {row?.original?.creator?.cluster?.name ? (
              <span className="text-[12px]">
                {row.original?.creator.cluster.name}
              </span>
            ) : (
              <span>--</span>
            )}
          </>
        );
      },
    },
    {
      header: 'No Of Applicant',
      accessorKey: 'status',

      Cell: ({ row }) => {
        return (
          <span className="text-[12px]">
            {row?.original?.no_of_practitioners}
          </span>
        );
      },
    },
    {
      header: 'Date Posted',
      Cell: ({ row }) => {
        const parseDate = (dateString) => {
          if (!dateString) return '';

          // Check if it's in ISO format (YYYY-MM-DDTHH:mm:ss.sssZ)
          if (dateString.includes('T')) {
            return new Date(dateString);
          }

          // Handle "DD-MM-YYYY" format by converting it to "YYYY-MM-DD"
          const parts = dateString.split('-');
          if (parts.length === 3) {
            const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`; // Convert to YYYY-MM-DD
            return new Date(formattedDate);
          }

          return new Date(dateString); // Fallback
        };

        const formattedDate = row?.original?.available_at
          ? new Intl.DateTimeFormat('en-GB', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
            }).format(parseDate(row.original?.available_at))
          : '';
        return <span className="text-[12px]">{formattedDate}</span>;
      },
    },
    {
      header: 'Due Date',
      Cell: ({ row }) => {
        const parseDate = (dateString) => {
          if (!dateString) return '';

          // Check if it's in ISO format (YYYY-MM-DDTHH:mm:ss.sssZ)
          if (dateString.includes('T')) {
            return new Date(dateString);
          }

          // Handle "DD-MM-YYYY" format by converting it to "YYYY-MM-DD"
          const parts = dateString.split('-');
          if (parts.length === 3) {
            const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`; // Convert to YYYY-MM-DD
            return new Date(formattedDate);
          }

          return new Date(dateString); // Fallback
        };

        const formattedDate = row?.original?.till
          ? new Intl.DateTimeFormat('en-GB', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
            }).format(parseDate(row.original?.till))
          : '';
        return (
          <span style={{ color: '#AF1D38' }} className="text-[12px]">
            {formattedDate}
          </span>
        );
      },
    },
    ...(user.role === 'physician_management'
      ? [
          {
            header: 'Status',
            Cell: ({ row }) => {
              const application = row?.original?.applications?.find(
                (position) => position?.user_id === user?.id
              );

              const hasApplied = !!application; // Convert to boolean
              const isRejected = application?.status === 'rejected';

              const displayText = isRejected
                ? 'Rejected'
                : hasApplied
                  ? 'Applied'
                  : 'Not Applied';
              return (
                <span className="flex justify-center px-[10px] py-[6px] items-center gap-[4px] rounded-md border border-[#E2E4E9] bg-white text-[#525866] font-inter text-xs font-medium leading-4 tracking-[0.02em]">
                  {displayText}
                </span>
              );
            },
          },
        ]
      : []),
  ];

  const renderRowActions = ({ row, table }) => {
    let isOpen = false;

    if (user?.role == 'physician_management') {
      if (row?.original?.applications.length > 0) {
      }
    } else {
      isOpen = false;
    }

    const isBlocked = row?.original?.physician?.actionStatus === 'blocked';

    return (
      <>
        <div className="flex gap-3">
          <RightArrow
            onClick={(e) => handleClick(e, row)}
            isDisabled={isOpen} // Set isOpen as condition to disable the button
          />
        </div>
      </>
    );
  };

  const handleRenderRowActions = ({ row, table }) =>
    renderRowActions({ row, table });

  const fetchRequests = async (filters, page, rowsPerPage) => {
    try {
      const payload = {
        cluster: String(filters.cluster || '').toLowerCase(),
        medical_speciality: String(
          filters.medicalSpecialties?.map((label) => label?.label).join(', ') ||
            ''
        ),
        job_number: String(filters.job_number || '').toLowerCase(),
        created_at: String(filters.date || '').toLowerCase(),
      };
      setloading(true);
      const response = await apiService.get(
        `announced-jobs?is_pagination=true&per_page=${rowsPerPage}&page=${page}`,
        payload
      );
      if (response?.code === 200) {
        setRequestList(response?.data?.data);
        setTotalRows(response?.data?.total);
        setloading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    // Cleanup the debounce function on unmount
    return () => handleDebouncedChange.cancel();
  }, []);

  React.useLayoutEffect(() => {
    fetchRequests(filters, page, rowsPerPage);
  }, [page, rowsPerPage]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center p-4 bg-gray-100 h-[60px]">
        <div className="grid gap-3 grid-cols-4">
          {/* English Name */}
          <input
            type="text"
            name="cluster"
            placeholder="Enter Cluster Name"
            value={filters.cluster}
            onChange={(e) => {
              handleInputChange(e, page, rowsPerPage); // Update state if input is valid
            }}
            className="px-3 py-[4px] border border-gray-300 rounded-[12px] focus:outline-none focus:ring-0 focus:bg-transparent"
          />
          <input
            type="text"
            name="job_number"
            placeholder="Enter Job Number"
            value={filters.job_number}
            onChange={(e) => {
              handleInputChange(e); // Update state if input is valid
            }}
            className="px-3 py-[4px] border border-gray-300 rounded-[12px] focus:outline-none focus:ring-0 focus:bg-transparent"
          />

          {/* Action Status */}

          <CustomDropDown
            name="medicalSpecialties"
            value={
              filters.medicalSpecialties?.map((site) => ({
                label: site?.label,
                value: site?.value,
              })) || []
            }
            onFieldSelect={(e) => {
              handleInputChange(e, page, rowsPerPage);
            }}
            options={medSp?.map(({ name, _id, ...rest }) => ({
              label: name,
              value: _id,
              ...rest,
            }))}
            zIndex={'99999'}
            isMulti={true}
          />

          <input
            type="date"
            name="date"
            placeholder="Date"
            value={filters.date}
            onChange={(e) => {
              handleInputChange(e, page, rowsPerPage); // Update state if input is valid
            }}
            className="px-3 py-[4px] border border-gray-300 rounded-[12px] focus:outline-none focus:ring"
          />
        </div>
        <p className="text-black text-right font-inter text-xs font-medium leading-[18px] tracking-[0.36px] self-center m-0">
          Total Count: {totalRows}
        </p>
      </div>

      <DataTableReact
        data={requestList}
        columns={columns}
        renderRowActions={handleRenderRowActions}
        Pagination={Pagination}
        totalRows={totalRows}
        prevPageUrl={prevPageUrl}
        nextPageUrl={nextPageUrl}
        setPage={setPage}
        page={page}
        setRowsPerPage={setRowsPerPage}
        rowsPerPage={rowsPerPage}
        loading={loading}
        shouldShowActions={true}
        idetifyer="announcment"
      />
    </div>
  );
};

export default Listing;

// isOpen = row?.original?.applications.some(item => item.user_id === user.id);
